import { validateForm } from "./lib-2sxc-forms";

export class Step {
  id: number;
  contentElementRef: HTMLElement;
  iconElementRef: HTMLElement;

  showOnFirstActivation: string;
  isFirstActivation: boolean = true;

  show(): string {
    if (this.contentElementRef) {
      this.contentElementRef.hidden = false;
    }

    if (this.iconElementRef) {
      this.iconElementRef.setAttribute("active", null);
    }

    if (this.isFirstActivation) {
      this.isFirstActivation = false;
      return this.showOnFirstActivation;
    }

    return null;
  }

  hide(): void {
    if (this.contentElementRef) {
      this.contentElementRef.hidden = true;
    }

    if (this.iconElementRef) {
      this.iconElementRef.removeAttribute("active");
    }
  }

  enable(): void {
    if (this.iconElementRef) {
      this.iconElementRef.removeAttribute("disabled");
    }
  }

  isValid(): boolean {
    if (this.contentElementRef) {
      return validateForm(this.contentElementRef);
    }

    return true;
  }
}

export class ProductConfiguratorState {
  constructor(schematic: GlassRoofSchematic | OtherSchematic) {
    this.schematic = schematic;
    this.steps = [] as Array<Step>;
    this.currentProgress = 1;
  }

  schematic: GlassRoofSchematic | OtherSchematic;
  steps: Step[];

  currentProgress: number;

  changeSchematic(
    newSchematic: GlassRoofSchematic | OtherSchematic,
    hideElements?: string[]
  ) {
    Object.keys(this.schematic).forEach((key) => {
      if (hideElements && hideElements.includes(key))
        this.hideSvgElements((this.schematic as any)[key] as string[]);

      if (!hideElements)
        this.hideSvgElements((this.schematic as any)[key] as string[]);
    });

    this.schematic = newSchematic;
  }

  getActiveStep(): Step {
    return this.steps.find((f) => f.contentElementRef.hidden == false);
  }

  addStep(newStep: Step) {
    newStep.hide();
    this.steps.push(newStep);
    this.steps.sort((a, b) => a.id - b.id)[0].show();
  }

  addIconToStep(stepId: number, iconElementRef: HTMLElement) {
    this.steps
      .filter((f) => f.id === stepId)
      .forEach((v) => (v.iconElementRef = iconElementRef));
  }

  getContentElementByStepId(stepId: number): HTMLElement {
    return this.steps.find((f) => f.id == stepId)?.contentElementRef;
  }

  gotoStep(stepId: number): boolean {
    if (this.currentProgress + 1 < stepId) return false;
    if (this.currentProgress < stepId) this.currentProgress = stepId;

    this.steps
      .filter((f) => f.contentElementRef.hidden == false)
      .forEach((v) => v.hide());

    this.steps
      .filter((f) => f.id == stepId)
      .forEach((step) => {
        const ret = step.show();
        if (ret) {
          const svgElementIds: string[] = (this.schematic as any)[ret];
          this.showSvgElements(svgElementIds);
        }
      });

    this.steps
      .filter((f) => f.id == stepId + 1)
      .forEach((step) => {
        step.enable();
      });

    return true;
  }

  triggerShowOnCheck(e: Element) {
    const showAttr = e.getAttribute("data-show-on-check");
    if (showAttr) {
      const svgElementIds: string[] = (this.schematic as any)[showAttr];
      this.showSvgElements(svgElementIds);
    }
  }

  hideSvgElements(svgElementIds: string[]) {
    if (svgElementIds && svgElementIds.length > 0) {
      svgElementIds.forEach((f) => {
        if (!!f) {
          const svgElement = document.getElementById(f);
          svgElement.style.display = "none";
        }
      });
    }
  }

  showSvgElements(svgElementIds: string[]) {
    if (svgElementIds && svgElementIds.length > 0) {
      svgElementIds.forEach((f) => {
        if (!!f) {
          const svgElement = document.getElementById(f);
          svgElement.style.display = "inline";
        }
      });
    }
  }

  triggerHideOnUncheck(e: Element) {
    const hideAttr = e.getAttribute("data-show-on-check");
    if (hideAttr) {
      const svgElementIds: string[] = (this.schematic as any)[hideAttr];
      this.hideSvgElements(svgElementIds);
    }
  }

  triggerShowOnSelect(e: Element) {
    const showAttr = e.getAttribute("data-show-on-select");
    if (showAttr) {
      const svgElementIds: string[] = (this.schematic as any)[showAttr];
      this.showSvgElements(svgElementIds);
    }
  }

  triggerHideOnSelect(e: Element) {
    const hideAttr = e.getAttribute("data-hide-on-select");
    if (hideAttr) {
      const svgElementIds: string[] = (this.schematic as any)[hideAttr];
      this.hideSvgElements(svgElementIds);
    }
  }

  triggerOnFocus(e: Element, blur?: boolean) {
    const focusAttr = e.getAttribute("data-show-on-focus");
    if (focusAttr) {
      const svgElementIds: string[] = (this.schematic as any)[focusAttr];
      if (svgElementIds && svgElementIds.length > 0) {
        svgElementIds.forEach((f) => {
          const svgElement = document.getElementById(f);
          svgElement.style.display = blur ? "none" : "inline";
        });
      }
    }
  }
}

export class GlassRoofSchematic {
  widthDimensioning: string[];
  depthDimensioning: string[];

  pillarInset: string[];
  pillarStandard: string[];

  westGlass: string[];
  southGlass: string[];
  eastGlass: string[];

  topCloth: string[];
  underGlassCloth: string[];

  westCloth: string[];
  southCloth: string[];
  eastCloth: string[];

  illuminationStripes: string[];
  illuminationStripesWithUnderGlassCloth: string[];
  illuminationSpots: string[];
  illuminationNone: string[];
}

export class OtherSchematic {}
